import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMShippingMethodAsync,
  deleteOMShippingMethodAsync,
  editOMShippingMethodAsync,
  getOMShippingMethodAsync,
} from "../../../store/services/orderManagementService";
const ShippingMethod = () => {
  const dispatch = useDispatch();
  const {
    getOMShippingMethodStatus,
    getOMShippingMethodError,
    getOMShippingMethodData,
    addOMShippingMethodStatus,
    addOMShippingMethodData,
    addOMShippingMethodError,

    editOMShippingMethodStatus,
    editOMShippingMethodError,
    editOMShippingMethodData,

    deleteOMShippingMethodData,
    deleteOMShippingMethodStatus,
    deleteOMShippingMethodError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMShippingMethodAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMShippingMethodData?.length
    ? getOMShippingMethodData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedShippingMethod, setSelectedShippingMethod] = useState();
  const [addShippingMethodMode, setAddShippingMethodMode] = useState(false);
  const [addShippingMethodData, setAddShippingMethodData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedShippingMethod", selectedShippingMethod);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMShippingMethodStatus === asyncStatus.SUCCEEDED) {
      setAddShippingMethodMode(false);
      setSaveDisabled(true);
      setAddShippingMethodData();
    }
  }, [, addOMShippingMethodStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMShippingMethodAsync(selectedShippingMethod?.term_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (
      deleteOMShippingMethodStatus === asyncStatus.SUCCEEDED ||
      deleteOMShippingMethodStatus === asyncStatus.ERROR
    ) {
      setOpen(false);
      setSelectedShippingMethod();
    }
  }, [, deleteOMShippingMethodStatus]);
  useEffect(() => {
    if (editOMShippingMethodStatus === asyncStatus.SUCCEEDED) {
      setSelectedShippingMethod();
      setEditMode(false);
      setEditData();
    }
  }, [, editOMShippingMethodStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  const handleChange = (fieldName, e) => {
    setAddShippingMethodData({
      ...addShippingMethodData,
      [fieldName]: e.target.value,
    });
  };
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this term for print?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Shipping Method"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Shipping Method
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddShippingMethodMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addShippingMethodMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addShippingMethodMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddShippingMethodMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addShippingMethodMode || !selectedShippingMethod}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMShippingMethodStatus === asyncStatus.LOADING ||
                  editOMShippingMethodStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addShippingMethodData) {
                    dispatch(addOMShippingMethodAsync(addShippingMethodData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedShippingMethod, ...editData };
                    delete a.id;
                    dispatch(editOMShippingMethodAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "shipping_method_id", headerName: "ID", flex: true },
                  {
                    field: "shipping_method_name",
                    headerName: "Shipping Method",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedShippingMethod(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMShippingMethodStatus === asyncStatus.IDLE ||
                  getOMShippingMethodStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addShippingMethodMode ? (
              <InputWithBtnLayoutComp
                error={addOMShippingMethodError}
                inputArray={[
                  {
                    label: "Shipping Method:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={
                          (e) => handleChange("shipping_name", e)
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={e => handleChange("is_active", e)}/>
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedShippingMethod ? (
              <InputWithBtnLayoutComp
                error={editOMShippingMethodError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedShippingMethod?.term_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "ShippingMethod:",
                    comp: (
                      <InputComp
                        key={selectedShippingMethod?.term_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            term_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedShippingMethod?.term_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={
                          selectedShippingMethod?.is_active ||
                          editData?.is_active
                        }
                        disabled={!editMode}
                        // defaultValue={selectedShippingMethod?.is_active || editData?.is_active}
                        defaultChecked={
                          selectedShippingMethod?.is_active ||
                          editData?.is_active
                        }
                        // checked={selectedShippingMethod?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Stack>
                <Typography>Select any shipping method for print</Typography>
                <Typography color={"red"} fontSize={12}>
                  {getOMShippingMethodError}
                </Typography>
              </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedShippingMethod(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedShippingMethod(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default ShippingMethod;
